module.exports = __webpack_public_path__ + "img/avatar.117c9b1c.svg";